import { xml2json } from 'xml-js';

const xmlToJson = xml => {
  try {
    let obj = {};
    if (xml.children.length > 0) {
      for (let i = 0; i < xml.children.length; i++) {
        const item = xml.children.item(i);
        const nodeName = item.nodeName;
        if (typeof obj[nodeName] == 'undefined') {
          obj[nodeName] = xmlToJson(item);
        } else {
          if (typeof obj[nodeName].push == 'undefined') {
            const old = obj[nodeName];
            obj[nodeName] = [];
            obj[nodeName].push(old);
          }
          obj[nodeName].push(xmlToJson(item));
        }
      }
    } else {
      obj = xml.textContent;
    }
    return obj;
  } catch (e) {
    // console.log(e.message);
  }
};

const xmlParser = xml => new DOMParser().parseFromString(String(xml), 'text/xml');

const xmlJson = xml => {
  return JSON.parse(xml2json(String(xml), { spaces: 2 }));
};

//TODO: Bad coding manipulation should be done in backend and we can remove dependencies also
const xmlToMessage = data => {
  let validationMessage = '';
  const fullData = xmlJson(data).elements[0]?.elements[0]?.elements[0]?.elements;
  for (let index = 0; index < fullData?.length; index++) {
    if (fullData[index]?.name === 'Message') {
      validationMessage += `<div> ${fullData[index]?.attributes?.Category} : ${fullData[index]?.attributes?.Description} </div>`;
    }
  }
  return validationMessage;
};

export { xmlToMessage, xmlParser, xmlToJson };
